import { SVGIcon } from './SVGIcon';

export default SVGIcon;
